import PropTypes from "prop-types";
import classNames from "classnames";

const IconRemove = ({ className, height = "20px", width = "20px" }) => {
    const classes = classNames("removeIcon", className);

    return (
        <svg
            className={classes}
            width={width}
            height={height}
            focusable="false"
            viewBox="0 0 15.65 15.65"
        >
            <polygon
                id="+"
                transform="rotate(-315 7.8190884590148935,7.108262062072755) translate(-30,-37) "
                points="39.81908944994211,43.10826139897108 47.81908944994211,43.10826139897108 47.81908944994211,46.10826139897108 39.81908944994211,46.10826139897108 39.81908944994211,54.10826139897108 36.81908944994211,54.10826139897108 36.81908944994211,46.10826139897108 28.81908754259348,46.10826139897108 28.81908754259348,43.10826139897108 36.81908944994211,43.10826139897108 36.81908944994211,35.10826139897108 39.81908944994211,35.10826139897108 "
            />
        </svg>
    );
};

IconRemove.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

export default IconRemove;
